/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

#SideBar {
  display: grid;
  grid-template-rows: auto auto auto 1fr;
  width: 100%;
  height: 100%;
}
